// Original source: /Users/matteo/projects/vareselab/backend/src/shared/user.ts
import { BaseUser } from "@/types/base-user";
import { Membership } from "./membership";

export enum InvoiceType {
  individual = 'individual',
  company = 'company'
}

export enum VerificationStatus {
  incomplete = 'incomplete',
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected'
}

export interface InvoiceInfo {
  type: InvoiceType;

  // For individuals (privati senza partita IVA)
  first_name?: string;
  last_name?: string;
  tax_code: string; // codice fiscale (always required)

  // For companies (società/professionisti con partita IVA)
  company_name?: string; // denominazione sociale o ragione sociale
  vat_number?: string; // partita IVA

  // Address (required for both)
  address: string;
  postal_code: string; // CAP
  city: string;
  province: string;
  country?: string;

  // For electronic invoicing (companies only)
  sdi_code?: string; // codice destinatario SDI
  pec_email?: string; // PEC per fatturazione elettronica
}

export interface User extends BaseUser {
  created_at: Date;
  updated_at: Date;
  first_name: string;
  last_name: string;
  avatar: string | null;
  profession: string | null;
  pin_gate: string | null;
  membership: Membership;
  invoice_info?: InvoiceInfo;
  linkedin_url?: string;
  verification_status?: VerificationStatus;
  preferences: {
    timezone: string;
    notifications: {
      email: boolean;
    };
  };
}